module.exports = __webpack_public_path__ + "img/sticker_24.6a3e34e7.svg";